// extracted by mini-css-extract-plugin
module.exports = {"tableHeading":"TableHeading-tableHeading-lnSuOmRLf7","fieldDesc":"TableHeading-fieldDesc-LSvimiyNH9","fieldName":"TableHeading-fieldName-2vuySPYfyV"};